import React, { useState } from "react";
import Image from "next/image";

interface AIChatbotSectionProps {
    sections: Section[];
}

interface Section {
    title: string;
    icon: string;
    title2?: string;
    desc?: string;
    features?: string[];
    img: string;
}

const AIChatbotSection: React.FC<AIChatbotSectionProps> = ({ sections }) => {
    const [currIndex, setCurrIndex] = useState(0);

    const handleBtnSelect = (index: number) => {
        setCurrIndex(index);
    };

    return (
        <section
            className="payments-spl-cont text-center hidden lg:block"
            style={
                {
                    "--max-width": "1280px",
                } as React.CSSProperties
            }
        >
            <h2 className="md:text-6xl text-4xl font-semibold pb-10 max-w-7xl mx-auto px-5 font-degular">Extra AI superpowers inside Gallabox</h2>

            <div
                className="button-cont-ai flex-row hidden sm:hidden md:block pb-0 px-24"
                style={
                    {
                        "--grid-columns": `repeat(${sections.length}, 1fr)`,
                    } as React.CSSProperties
                }
            >
                {sections.map((section, index) => (
                    <button key={section.title} onClick={() => handleBtnSelect(index)} className={`${currIndex === index ? "selected-button-ai" : "button-cont-ai-inactive"}`}>
                        <div className="flex row justify-center items-center">
                            <Image width={16} height={16} src={section.icon} alt={`Icon ${index}`} className="button-icon w-5 h-5" />
                            <p style={{ marginLeft: "10px" }} className="text-md font-inter">
                                {section.title}
                            </p>
                        </div>
                    </button>
                ))}
            </div>

            <div className="bg-lightBlue rounded-2xl">
                <div className="flex">
                    <div className="w-1/2 p-10 flex flex-col mt-40  text-left">
                        <div className="mb-8">
                            <h3 className="font-semibold text-4.5xl font-degular">{sections[currIndex]?.title2 || sections[currIndex]?.title}</h3>
                            {sections[currIndex]?.desc && <p className="text-lg pt-4 font-inter">{sections[currIndex]?.desc}</p>}
                            <ul className="list-none mt-4" style={{ marginLeft: "0px !important" }}>
                                {sections[currIndex]?.features?.map((feature, idx) => (
                                    <div key={idx} className="flex items-center gap-1">
                                        <div className="flex-shrink-0">
                                            <Image src={"https://assets.gallabox.com/gb-home/ai-chatbot/lightblue-circle-tick.svg"} width={24} height={24} alt="tick-circle" />
                                        </div>
                                        <li className="list-none text-md font-inter  text-base">{feature}</li>
                                    </div>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="w-1/2 flex justify-center items-center">
                        <div className="fi max-w-full max-h-full p-10">
                            <Image width={430} height={430} className="rounded-3xl" src={sections[currIndex]?.img} alt={`Image ${currIndex}`} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AIChatbotSection;
